const Icon = require("app/shared/components/Icon/icon");
var BoldText = require("app/shared/components/BoldText/bold-text");

function Card({
    className = "",
    title,
    children,
    control,
    footer = <span>&nbsp;</span>
  }) {
  return (
    <div className={`${className} d-f flex-column`}>
      <div className="d-f align-center text-muted">  
        {title}
        {control}
      </div>

      <article className={`p-20 u-boxShadow-medium bg-white flex-1 br-4`}>
        {children}
      </article>

      <div className="mt-10 text-left fs-12 dashboard-card-footer">
        {footer}
      </div>
    </div>
  );
};

module.exports = Card;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/card.jsx